export function toolActivityHostname(
  url: string | undefined,
): string | undefined {
  if (!url) {
    return undefined;
  }
  try {
    return new URL(url).hostname;
  } catch {
    return url.replace(/^https?:\/\//, "").split("/")[0] || undefined;
  }
}
